import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo, useState } from 'react';
import { SearchField, SegmentedControl, Table, useLocalizeMessage } from 'libs.nucleus';
import { ConsentUploadZone } from '../components/consent_upload_zone.component';
import { useConsentTableColumns } from '../hooks/use_consent_table_columns.hook';
export const ConsentManagerUI = ({ files, onFilesUploaded, onEdit, onEditRow, archiveTemplateVersion: removeFileFromStorage, }) => {
    const translate = useLocalizeMessage();
    const [statusFilterIndex, setStatusFilterIndex] = useState(0);
    const [searchValue, setSearchValue] = useState('');
    const statusFilterItems = useMemo(() => [
        { id: 'all', label: translate('All') },
        { id: 'published', label: translate('Published') },
        { id: 'draft', label: translate('Draft') },
        { id: 'archived', label: translate('Archived') },
    ], [translate]);
    const filteredFiles = useMemo(() => {
        let result = files;
        if (statusFilterIndex === 1) {
            result = result.filter((f) => f.status === 'Published');
        }
        else if (statusFilterIndex === 2) {
            result = result.filter((f) => f.status === 'Draft');
        }
        else if (statusFilterIndex === 3) {
            result = result.filter((f) => f.status === 'Archived');
        }
        if (searchValue.trim()) {
            const term = searchValue.toLowerCase();
            result = result.filter((f) => f.title.toLowerCase().includes(term) ||
                f.description.toLowerCase().includes(term) ||
                f.language.toLowerCase().includes(term));
        }
        return result;
    }, [files, statusFilterIndex, searchValue]);
    const columns = useConsentTableColumns({ onEdit, onEditRow, removeFileFromStorage });
    return (_jsxs("div", { className: 'nucleus-flex nucleus-flex-col', children: [_jsx(ConsentUploadZone, { onFileAdd: onFilesUploaded }), _jsx(Table, { columns: columns, data: filteredFiles, getRowId: (row) => row.id, labelNoResults: translate('No consent files have been added'), customHeaderContent: _jsxs("div", { className: 'nucleus-flex nucleus-items-end nucleus-gap-4 nucleus-w-full', children: [_jsx(SegmentedControl, { items: statusFilterItems, activeItemIndex: statusFilterIndex, onItemClick: (_, index) => setStatusFilterIndex(index) }), _jsx(SearchField, { ariaLabel: translate('Search'), placeholder: translate('Search...'), value: searchValue, onChange: (e) => setSearchValue(e.target.value), onClear: () => setSearchValue(''), width: 'base', dataTestId: 'consent-search' })] }) })] }));
};
